import { MapVenue } from 'js/model/view/map-view/MapVenue';
import { BrowsePageOutput } from 'js/model/rainbow/browse-page/BrowsePageOutput';

export function getMapVenues(browsePageOutput: BrowsePageOutput): MapVenue[] {
  const results = browsePageOutput.results;

  const mapVenues: MapVenue[] = results.map((venue) => ({
    id: venue.data.id,
    name: venue.data.name,
    location: venue.data.location.point,
    rating: venue.data.rating,
    primaryImage: venue.data.primaryImage,
    menuItems: venue.data.menuHighlights,
    result: venue,
    listingSpecification: browsePageOutput.specification,
  }));

  return mapVenues;
}

export function getTotalResults(mapVenues: MapVenue[]): number {
  return mapVenues.length;
}

export function getAverageRating(mapVenues: MapVenue[]): number {
  const totalRating = mapVenues.reduce(
    (ratingTotal, mapVenue) => ratingTotal + mapVenue.rating.average,
    0
  );
  return parseFloat((totalRating / getTotalResults(mapVenues)).toFixed(1));
}
